export function whenWafBotControlReady(callback: () => void) {
  const isWafBotControlReady = window.Treatwell?.wafBotControlReady;
  if (isWafBotControlReady) {
    isWafBotControlReady.then(callback);
  } else {
    callback();
  }
}
